// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `style attribute {
    --base-color: #0038e3;
}
header .navbar-brand img { max-height: 110px; margin-left: 30px; }
.climsedis_menu .nav-link{ font-size: 16px; }

input.errors-danger[type=checkbox], textarea.errors-danger[type=checkbox] {
    box-shadow: 0 0 0 1px red,1px 1px 0 0 red;
}
.errors-danger{
    --tw-border-opacity: 1;
    border-color: rgb(255 0 0/var(--tw-border-opacity)) !important;
}
.errors-danger span, label.errors-danger{
    color: rgb(255 0 0) !important;;
}
.date-range{ border: 1px solid gray; }
.react-datepicker__month-wrapper { margin: 10px; font-size: larger; }

._loading_overlay_content {
  top: 45%;
  left: 35%;
  position: fixed;
}
.btn_radio input[type="radio"]{
  visibility: hidden;
  height: 0;
  width: 0;
}
.btn_radio .div_radio label{
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    padding: 5px 10px;
    border: 1px solid gray;
    border-radius: 5px;
    margin: 0px 3px;
    cursor: pointer;
    transition: all .3s ease-out;
}

.btn_radio .div_radio label:has(input:checked){
    border: 1px solid red;
    background: antiquewhite;
}
.btn_radio .div_radio input[type="radio"]:checked + label{
  background-color: antiquewhite;
}
.disclaimer{ border: 0.5px solid #EF672A; }

@media screen and (min-width: 640px){
    #map, #map_2{ width: 600px; }
    .btn_radio .div_radio label{ padding: 0px 2px; }
    .params{ width: 600px !important; }
    .model_outputs{ width: 100vw; position: relative; left: calc(1vw); margin: 10px 0px !important; }
    .model_outputs div{ width: 90vw;}
    .forecast_period, .model_type{ width: 48%; padding: 0px 10px; }
    .model_type{ float: left; } 
    .regions{ width: 100% }
}

@media screen and (min-width: 790px){
    #map, #map_2{ width: calc(100vw-230px); }
    .params{ width: 200px !important; max-width: 250px !important; padding-left: 5px !important; padding-right: 5px !important; max-height: calc(90vh); overflow-y: auto; }
    .model_outputs{ width: 100%; left: 5px; margin: 10px 0px !important; padding: 0px 0px 0px 10px !important; }
    .model_outputs div{ width: 100%;}
    .model_type{ float: none; padding: 0px; }
    .forecast_period, .model_type{ width: 100%; }
}

@media screen and (min-width: 1024px){
    #map, #map_2{ width: 790px; }
    .btn_radio .div_radio label{ padding: 2px 5px; }
    .params{ width: 250px !important; max-width: 250px !important; padding-left: 5px !important; padding-right: 5px !important; }
}

@media screen and (min-width: 1280px){
    #map, #map_2{ width: 900px; }
    .params{ width: 260px !important; max-width: 300px !important; padding-left: 10px !important; padding-right: 10px !important; }
}

@media screen and (min-width: 1540px){
    #map, #map_2{ width: 1160px; }
    .params{ width: 350px !important; max-width: 400px !important; }
}

@media screen and (min-width: 1800px){
    #map, #map_2{ width: 1440px; }
}

@media screen and (min-width: 2024px){
    #map, #map_2{ width: 1664px; }
}`, "",{"version":3,"sources":["webpack://./src/Assets/css/climsedis.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;AACA,2BAA2B,iBAAiB,EAAE,iBAAiB,EAAE;AACjE,2BAA2B,eAAe,EAAE;;AAE5C;IACI,yCAAyC;AAC7C;AACA;IACI,sBAAsB;IACtB,8DAA8D;AAClE;AACA;IACI,8BAA8B;AAClC;AACA,aAAa,sBAAsB,EAAE;AACrC,mCAAmC,YAAY,EAAE,iBAAiB,EAAE;;AAEpE;EACE,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAElB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA,aAAa,2BAA2B,EAAE;;AAE1C;IACI,cAAc,YAAY,EAAE;IAC5B,6BAA6B,gBAAgB,EAAE;IAC/C,SAAS,uBAAuB,EAAE;IAClC,gBAAgB,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,2BAA2B,EAAE;IAChG,oBAAoB,WAAW,CAAC;IAChC,+BAA+B,UAAU,EAAE,iBAAiB,EAAE;IAC9D,aAAa,WAAW,EAAE;IAC1B,UAAU,YAAY;AAC1B;;AAEA;IACI,cAAc,wBAAwB,EAAE;IACxC,SAAS,uBAAuB,EAAE,2BAA2B,EAAE,4BAA4B,EAAE,6BAA6B,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;IACtK,gBAAgB,WAAW,EAAE,SAAS,EAAE,2BAA2B,EAAE,oCAAoC,EAAE;IAC3G,oBAAoB,WAAW,CAAC;IAChC,aAAa,WAAW,EAAE,YAAY,EAAE;IACxC,+BAA+B,WAAW,EAAE;AAChD;;AAEA;IACI,cAAc,YAAY,EAAE;IAC5B,6BAA6B,gBAAgB,EAAE;IAC/C,SAAS,uBAAuB,EAAE,2BAA2B,EAAE,4BAA4B,EAAE,6BAA6B,EAAE;AAChI;;AAEA;IACI,cAAc,YAAY,EAAE;IAC5B,SAAS,uBAAuB,EAAE,2BAA2B,EAAE,6BAA6B,EAAE,8BAA8B,EAAE;AAClI;;AAEA;IACI,cAAc,aAAa,EAAE;IAC7B,SAAS,uBAAuB,EAAE,2BAA2B,EAAE;AACnE;;AAEA;IACI,cAAc,aAAa,EAAE;AACjC;;AAEA;IACI,cAAc,aAAa,EAAE;AACjC","sourcesContent":["style attribute {\n    --base-color: #0038e3;\n}\nheader .navbar-brand img { max-height: 110px; margin-left: 30px; }\n.climsedis_menu .nav-link{ font-size: 16px; }\n\ninput.errors-danger[type=checkbox], textarea.errors-danger[type=checkbox] {\n    box-shadow: 0 0 0 1px red,1px 1px 0 0 red;\n}\n.errors-danger{\n    --tw-border-opacity: 1;\n    border-color: rgb(255 0 0/var(--tw-border-opacity)) !important;\n}\n.errors-danger span, label.errors-danger{\n    color: rgb(255 0 0) !important;;\n}\n.date-range{ border: 1px solid gray; }\n.react-datepicker__month-wrapper { margin: 10px; font-size: larger; }\n\n._loading_overlay_content {\n  top: 45%;\n  left: 35%;\n  position: fixed;\n}\n.btn_radio input[type=\"radio\"]{\n  visibility: hidden;\n  height: 0;\n  width: 0;\n}\n.btn_radio .div_radio label{\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n    cursor: pointer;\n    padding: 5px 10px;\n    border: 1px solid gray;\n    border-radius: 5px;\n    margin: 0px 3px;\n    cursor: pointer;\n    transition: all .3s ease-out;\n}\n\n.btn_radio .div_radio label:has(input:checked){\n    border: 1px solid red;\n    background: antiquewhite;\n}\n.btn_radio .div_radio input[type=\"radio\"]:checked + label{\n  background-color: antiquewhite;\n}\n.disclaimer{ border: 0.5px solid #EF672A; }\n\n@media screen and (min-width: 640px){\n    #map, #map_2{ width: 600px; }\n    .btn_radio .div_radio label{ padding: 0px 2px; }\n    .params{ width: 600px !important; }\n    .model_outputs{ width: 100vw; position: relative; left: calc(1vw); margin: 10px 0px !important; }\n    .model_outputs div{ width: 90vw;}\n    .forecast_period, .model_type{ width: 48%; padding: 0px 10px; }\n    .model_type{ float: left; } \n    .regions{ width: 100% }\n}\n\n@media screen and (min-width: 790px){\n    #map, #map_2{ width: calc(100vw-230px); }\n    .params{ width: 200px !important; max-width: 250px !important; padding-left: 5px !important; padding-right: 5px !important; max-height: calc(90vh); overflow-y: auto; }\n    .model_outputs{ width: 100%; left: 5px; margin: 10px 0px !important; padding: 0px 0px 0px 10px !important; }\n    .model_outputs div{ width: 100%;}\n    .model_type{ float: none; padding: 0px; }\n    .forecast_period, .model_type{ width: 100%; }\n}\n\n@media screen and (min-width: 1024px){\n    #map, #map_2{ width: 790px; }\n    .btn_radio .div_radio label{ padding: 2px 5px; }\n    .params{ width: 250px !important; max-width: 250px !important; padding-left: 5px !important; padding-right: 5px !important; }\n}\n\n@media screen and (min-width: 1280px){\n    #map, #map_2{ width: 900px; }\n    .params{ width: 260px !important; max-width: 300px !important; padding-left: 10px !important; padding-right: 10px !important; }\n}\n\n@media screen and (min-width: 1540px){\n    #map, #map_2{ width: 1160px; }\n    .params{ width: 350px !important; max-width: 400px !important; }\n}\n\n@media screen and (min-width: 1800px){\n    #map, #map_2{ width: 1440px; }\n}\n\n@media screen and (min-width: 2024px){\n    #map, #map_2{ width: 1664px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
